export const RARITIES = {
  common: {
    id: 'common',
    label: 'Common',
    color: '#9e9e9e',
    glow: 'rgba(158, 158, 158, 0.2)',
    weight: 55,
  },
  uncommon: {
    id: 'uncommon',
    label: 'Uncommon',
    color: '#43a047',
    glow: 'rgba(67, 160, 71, 0.2)',
    weight: 25,
  },
  rare: {
    id: 'rare',
    label: 'Rare',
    color: '#1e88e5',
    glow: 'rgba(30, 136, 229, 0.2)',
    weight: 12,
  },
  epic: {
    id: 'epic',
    label: 'Epic',
    color: '#8e24aa',
    glow: 'rgba(142, 36, 170, 0.2)',
    weight: 6,
  },
  legendary: {
    id: 'legendary',
    label: 'Legendary',
    color: '#ff9800',
    glow: 'rgba(255, 152, 0, 0.2)',
    weight: 2,
  },
};

export const RARITY_ORDER = ['common', 'uncommon', 'rare', 'epic', 'legendary'];

export const getRarity = (key) =>
  RARITIES[String(key || '').trim().toLowerCase()] || RARITIES.common;
